import { paginationPageSize } from "@/Constant";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
let ballotRelatedTabs = {
  creditorVotesTabState: {
    ballotVersionId: null,
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "VoterName",
    PageSize: paginationPageSize,
    sortedColumnTypes: { voterNameType: { sort: "asc" } },
  },
};
let schemeRelatedTabs = {
  schemeSummaryTabState: {
    schemeVersionId: "",
    isDraft: "",
  },
  schemePreviewTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "",
    SortColumn: "",
    PageSize: paginationPageSize,
    sortedColumnTypes: {},
    formValues: null,
    clearSearch: false,
    selectedCreditorId: "",
    isSearchActive: false,
    schemeVersion: "",
    isPreviewScheme: false,
  },
};
let paymentRelatedTabs = {
  paymentSummaryTabState: {
    PaymentId: "",
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "ClaimItemReference",
    PageSize: paginationPageSize,
    sortedColumnTypes: { claimIdType: { sort: "asc" } },
  },
};
let creditorRelatedTabs = {
  creditorId: "",
  creditorClaimsTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "UpdatedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { updatedOnType: { sort: "desc" } },
    basicSearchPayload: {},
    isBasicSearchApplied: false,
  },
  creditorAttributeHisTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "CreatedDate",
    PageSize: paginationPageSize,
    sortedColumnTypes: { createdDate: { sort: "desc" } },
  },
  creditorSettelmentTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "PaymentReference",
    PageSize: paginationPageSize,
    sortedColumnTypes: { paymentReference: { sort: "asc" } },
  },
  creditorDistributionTabState: {
    PageNumber: 1,
    SearchText: "",
    PageSize: paginationPageSize,
    SortOrder: "asc",
    SortColumn: "PaymentReference",
    sortedColumnTypes: { paymentReference: { sort: "asc" } },
    showFilter: false,
    filterPayload: null,
    isFilterActive: false,
    formValues: null,
  },
};
let claimRelatedTabs = {
  claimId: "",
  claimHistoryTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "ModifiedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { modifiedOnType: { sort: "desc" } },
    showHistoryGrid: "",
  },
  claimElementsHistoryTabState: {
    ClaimHistorySnapshotId: "",
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "ClaimItemReference",
    PageSize: paginationPageSize,
    sortedColumnTypes: { claimItemReferenceType: { sort: "asc" } },
    showHistoryGrid: "",
    isDefaultUnit: true,
  },
  claimAttributeHistoryTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "CreatedDate",
    PageSize: paginationPageSize,
    sortedColumnTypes: { createdDateType: { sort: "desc" } },
  },
};
let distributionRelatedTabs = {
  distributionId: "",
  stepDistributionTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "SortOrder",
    PageSize: paginationPageSize,
    sortedColumnTypes: { sortOrderType: { sort: "asc" } },
  },
};
let debitorRelatedTabs = {
  debtorId: "",
  debtorClaimsTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "UpdatedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { updatedOnType: { sort: "desc" } },
    basicSearchPayload: {},
    isBasicSearchApplied: false,
  },
};
let importRelatedTabs = {
  importHistoryTabState: {
    importId: "",
    PageNumber: 1,
    SearchText: "",
    SortOrder: "",
    SortColumn: "",
    PageSize: paginationPageSize,
    sortedColumnTypes: {},
    isStatusFilter: false,
    isSuccess: true,
  },
};
let caseComponentState = {
  caseDetailsViewTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "Role",
    PageSize: paginationPageSize,
    sortedColumnTypes: { roleType: { sort: "desc" } },
  },
  caseDetailsEditTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "",
    SortColumn: "",
    PageSize: paginationPageSize,
    sortedColumnTypes: {},
  },
  creditorListTabState: {
    PageNumber: 1,
    SearchText: "",
    PageSize: paginationPageSize,
    sortedColumnTypes: { creditorNameType: { sort: "asc" } },
    SortOrder: "asc",
    SortColumn: "CreditorName",
    advanceSearchPayload: {},
    isAdvanceSearchActive: false,
    basicSearchPayload: undefined,
    isSearchActive: false,
    isBasicSearchActive: false,
    clearSearch: false,
    searchUrl: {},
    formValues: null,
  },
  claimListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "UpdatedOn",
    PageSize: paginationPageSize,
    isBasicSearchActive: false,
    isAdvanceSearchActive: false,
    advanceSearchPayload: {},
    basicSearchPayload: {},
    isSearchActive: false,
    sortedColumnTypes: {
      lastUpdatedDateType: { sort: "desc" },
    },
  },
  ballotListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "BallotName",
    PageSize: paginationPageSize,
    sortedColumnTypes: { ballotNameType: { sort: "asc" } },
  },
  distributionListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "DistributionDate",
    PageSize: paginationPageSize,
    sortedColumnTypes: { distributionDateType: { sort: "desc" } },
  },
  manualDataListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "UpdatedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { updatedOnType: { sort: "desc" } },
  },
  payeeTypeListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "Name",
    PageSize: paginationPageSize,
    sortedColumnTypes: { nameType: { sort: "asc" } },
  },
  bankTransactionListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "UploadedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { uploadedOnType: { sort: "desc" } },
  },
  paymentsList: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "",
    SortColumn: "",
    PageSize: paginationPageSize,
    sortedColumnTypes: {
      accountNameType: { sort: "desc", initialSortIndex: 1 },
      prefixType: { sort: "desc", initialSortIndex: 2 },
      paymentReferenceType: { sort: "desc", initialSortIndex: 3 },
    },
    filterPayload: null,
    isFilterActive: false,
    formValues: null,
  },

  currencyListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "Name",
    PageSize: paginationPageSize,
    sortedColumnTypes: { unitNameType: { sort: "asc" } },
  },
  attributeListTabState: {
    entityType: 1,
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "Name",
    PageSize: paginationPageSize,
    sortedColumnTypes: { nameType: { sort: "asc" } },
  },
  schemeListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "Name",
    PageSize: paginationPageSize,
    sortedColumnTypes: { nameType: { sort: "asc" } },
  },
  categoryListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "Name",
    PageSize: paginationPageSize,
    sortedColumnTypes: { categoryNameType: { sort: "asc" } },
  },
  debtorListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "Name",
    PageSize: paginationPageSize,
    sortedColumnTypes: { nameType: { sort: "asc" } },
  },
  importListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "CreatedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { createdOnType: { sort: "desc" } },
  },
  reportingTabState: {
    CaseId: "",
    PageNumber: 1,
    SearchText: "",
    SortOrder: "desc",
    SortColumn: "CreatedOn",
    PageSize: paginationPageSize,
    sortedColumnTypes: { createdOnType: { sort: "desc" } },
    reportId: "1",
    reportType: "0",
    FromDate: "",
    ToDate: "",
    ReportType: "  ",
  },
  tasksListTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "",
    SortColumn: "",
    PageSize: paginationPageSize,
    sortedColumnTypes: {},
    formValues: null,
    clearSearch: false,
  },
  ...paymentRelatedTabs,
  ...creditorRelatedTabs,
  ...claimRelatedTabs,
  ...distributionRelatedTabs,
  ...debitorRelatedTabs,
  ...importRelatedTabs,
  ...schemeRelatedTabs,
  ...ballotRelatedTabs,
};

let componentState = {
  caseId: "",
  allCasesTabState: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "CaseName",
    PageSize: paginationPageSize,
    sortedColumnTypes: { caseNameType: { sort: "asc" } },
  },
  userManagementStateTab: {
    PageNumber: 1,
    SearchText: "",
    SortOrder: "asc",
    SortColumn: "ApplicationRole",
    PageSize: paginationPageSize,
    sortedColumnTypes: { applicationRoleType: { sort: "asc" } },
  },
  ...caseComponentState,
};

const retainState = createSlice({
  name: "formDefaults",
  initialState: { ...componentState },
  reducers: {
    setComponentState1: (
      state: any,
      action: PayloadAction<{ entityName: string; entityState: any }>
    ) => {
      let entityName = action.payload.entityName;
      let entityState = action.payload.entityState;
      if (entityName && entityState) {
        state[entityName] = {
          ...state[entityName],
          ...entityState,
        };
      }
      return state;
    },

    setComponentState: (state: any, action: PayloadAction<any>) => {
      state = { ...state, ...action.payload };
      return state;
    },
    setRetainCaseId: (state: any, action: PayloadAction<any>) => {
      if (action.payload.caseId !== state.caseId && state.caseId) {
        state = { ...state, ...action.payload, ...caseComponentState };
        return state;
      }
      state = { ...state, ...action.payload };
      return state;
    },
    setRetainCreditorId: (state: any, action: PayloadAction<any>) => {
      if (action.payload.creditorId !== state.creditorId && state.creditorId) {
        state = { ...state, ...action.payload, ...creditorRelatedTabs };
        return state;
      }
      state = { ...state, ...action.payload };
      return state;
    },
    setRetainClaimId: (state: any, action: PayloadAction<any>) => {
      if (action.payload.claimId !== state.claimId && state.claimId) {
        state = { ...state, ...action.payload, ...claimRelatedTabs };
        return state;
      }
      state = { ...state, ...action.payload };
      return state;
    },
    setRetainDistributionId: (state: any, action: PayloadAction<any>) => {
      if (
        action.payload.distributionId !== state.distributionId &&
        state.distributionId
      ) {
        state = { ...state, ...action.payload, ...distributionRelatedTabs };
        return state;
      }
      state = { ...state, ...action.payload };
      return state;
    },
    setRetainDebtorId: (state: any, action: PayloadAction<any>) => {
      if (action.payload.debtorId !== state.debtorId && state.debtorId) {
        state = { ...state, ...action.payload, ...debitorRelatedTabs };
        return state;
      }
      state = { ...state, ...action.payload };
      return state;
    },
    setRetainImportId: (state: any, action: PayloadAction<any>) => {
      if (action.payload.importId !== state.importId && state.importId) {
        state = { ...state, ...action.payload, ...importRelatedTabs };
        return state;
      }
      state = { ...state, ...action.payload };
      return state;
    },
    resetCaseComponentStates: (state: any) => {
      state = { ...state, ...caseComponentState };
      return state;
    },
  },
});

export const {
  setComponentState,
  resetCaseComponentStates,
  setRetainCaseId,
  setRetainCreditorId,
  setComponentState1,
  setRetainClaimId,
  setRetainDistributionId,
  setRetainDebtorId,
  setRetainImportId,
} = retainState.actions;
export default retainState.reducer;
